import { useCallback } from 'react'

import { UnderstandApiProps } from 'services/account-info/types'

import { Divider, Text, Accordion } from '@interco/inter-toranja'
import { interWbSession } from '@interco/inter-webview-bridge'
import { Spacing } from '@interco/inter-ui/components/Spacing'
import { TextSize, TextWeight } from '@interco/inter-toranja/dist/components/Atoms/Text/types'

interface UnderstandProps {
  data: UnderstandApiProps
}

export const Understand = ({ data }: UnderstandProps) => {
  const handleAccordionClick = useCallback(() => {
    interWbSession.requestAnalytics('FAQ_DUVIDA', {
      ref_figma: '68',
      flow: 'dados-bancarios',
      screen: 'dados-bancarios',
      content_name: data.tituloEntenda,
      correntista: 'true',
      product: 'global-account',
    })
  }, [data.tituloEntenda])

  return (
    <div
      style={{
        padding: '0 4px',
        display: 'flex',
        flexDirection: 'column',
        gap: 'var(--spacing-16)',
      }}
    >
      <Accordion title={data.tituloEntenda} onTag={handleAccordionClick} sizeTitle={TextSize.Large}>
        {data.informacoes.map((info, index) => (
          <div key={info.title}>
            <Text textType="body" textSize="medium" textWeight={TextWeight.Bold}>
              {info.title}
            </Text>

            <Spacing mt="xxs">
              <Text textType="body" textSize="medium">
                {info.message}
              </Text>
            </Spacing>

            {index < data.informacoes.length - 1 && (
              <Spacing my="sm">
                <Divider variant="solid" />
              </Spacing>
            )}
          </div>
        ))}
      </Accordion>
    </div>
  )
}
